// @ts-nocheck
/* eslint-disable */
import SceneMarkerMapyWindy from "~/scene/marker/mapy-windy";
import SceneCoordsInterface from "~/scene/icoords";

export interface IFeatureInfo {
	name: string;
	type: string;
}

export default class SceneMarkerMapyWindyPlace extends SceneMarkerMapyWindy {
	constructor(scene: any, itemId: string, coords: SceneCoordsInterface, item: any, opts: any, id: string) {
		super(scene, itemId, coords, id ? id : item.id, opts);

		this._item = item;
	}

	get featureInfo(): IFeatureInfo {
		return {
			name: "SceneMarkerMapyWindyPlace",
			type: "marker"
		};
	}

	getCreateData(): any {
		let rd = super.getCreateData();

		rd.item = this._item;

		return rd;
	}

	setInteractive(set?: boolean) {
		this._onChange(this._scene.featureEvent("markerMapyWMSetInteractive", true, true), arguments);
	}

	setNonInteractive(set?: boolean) {
		this._onChange(this._scene.featureEvent("markerMapyWMSetNonInteractive", true, true), arguments);
	}
}
